import { WorkspacePrebidConfiguration } from 'features/globalSetup/types/workspacePrebidConfiguration'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_PREBID_CONFIGURATION } from './api/query'
import { Data, Variables } from './api/types'
import {
  UseGetWorkspacePrebidConfiguration,
  UseGetWorkspacePrebidConfigurationParams,
} from './types'

export const useGetWorkspacePrebidConfiguration = ({
  workspaceId,
}: UseGetWorkspacePrebidConfigurationParams): UseGetWorkspacePrebidConfiguration => {
  const { data } = useQuery<Variables, Data, WorkspacePrebidConfiguration>({
    options: {
      enabled: workspaceId !== undefined,
      select: ({ workspacePrebidConfiguration }: Data): undefined | WorkspacePrebidConfiguration =>
        workspacePrebidConfiguration ? fromDTO(workspacePrebidConfiguration) : undefined,
    },
    query: GET_WORKSPACE_PREBID_CONFIGURATION,
    variables: {
      workspaceId,
    },
  })

  return {
    workspacePrebidConfiguration: data,
  }
}
